// Multivariate Dependencies
import React, { Suspense } from 'react';
// Component
import { Skeleton } from '../../../../atoms/Skeleton';
export var SuspenseWrapper = function (_a) {
    var children = _a.children, _b = _a.fallback, fallback = _b === void 0 ? React.createElement(Skeleton, { ariaLabel: 'suspense-wrapper-skeleton', ariaValueText: 'Please wait' }) : _b;
    return React.createElement(Suspense, { fallback: fallback }, children);
};
//# sourceMappingURL=SuspenseWrapper.js.map